import { colors } from './colors';
import { ExtendedTheme } from './themes';

export const darkPalette: ExtendedTheme = {
  palette: {
    mode: 'dark',
    success: {
      main: '#097c4f',
      dark: '#16b674',
      // light: '#3fcf8e1a',
      light: '#06281D',
    },
    info: {
      main: '#297ceb',
      dark: '#256faf',
      light: '#3BABFF',
    },
    error: {
      main: `#e5484d`, //icon color
      light: `#541c15`, //bg color
      dark: `#7f2315`, //border color
      hoverBg: '#e54d2e80',
      hoverBorder: '#e54d2e',
    },
    warning: {
      main: '#db8e00',
      dark: '#4a2900',
      light: '#291900',
    },
    primary: {
      main: `#21449d`, //main color for button
      light: `#3e8ecf4d`, // button border
      dark: '#3e8ecf', // border on hover
      contrastText: '#3e8ecf80', // bg on hover
    },
    secondary: {
      main: '#3babff',
      dark: '#76a7dc',
    },
    background: {
      default: '#171717',
      paper: '#242424',
    },
    common: {
      black: '#ffffff',
      white: '#000000',
    },
    divider: `${colors.darkBorder}`,
    text: {
      primary: `${colors.white}`,
      secondary: `${colors.darkIcons}`,
      disabled: '#898989',
    },
    action: {
      hover: `${colors.darkIconHover}`,
    },
  },
};
